import { useEffect, useState } from 'react';
import { AdPartner } from '../../../../react/Components/AdPartner';

const CallbackExpired = ({ pageAds = {} }) => {
    const [phoneNumber, setPhoneNumber] = useState('(877) 907-5267');

    useEffect(() => {
        if (window.lead_phone) {
            setPhoneNumber(window.lead_phone);
        }
    }, []);

    return (
        <div className="callback-container">
            <div className="heading-section">
                <div className="heading-section__text">
                    <h1 className="">
                        This link has expired but we are still here to help you with your business insurance needs.
                    </h1>
                    <p>
                        Please give us a call at <a href={`tel:${phoneNumber}`}>{phoneNumber}</a> to get matched to an
                        insurance provider.
                    </p>
                </div>
                <img className="heading-section__cta" src="/images/final-step-hero.webp" alt="Callback linkexpired" />
            </div>
            {pageAds.length > 0 && (
                <div className="ad-container">
                    <p className="disclosure-label">Important Advertising Disclosure Below</p>
                    <div className="paid-partners">
                        {pageAds.map((ad, index) => (
                            <AdPartner key={ad.id} adIndex={index} partnerData={ad} />
                        ))}
                    </div>
                    <div className="disclosure-container">
                        <label className="disclosure-text">
                            <strong>Disclaimer:</strong> The advertisers appearing on this website are providers of
                            insurance products and services from which Tivly receives compensation (“Sponsors”).
                            Compensation may impact where the Sponsors appear on this website (including the order in
                            which they appear). Our websites do not, and are not intended to, provide a comprehensive
                            list of all companies that may provide the products and services you are seeking.
                        </label>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CallbackExpired;
